import React from 'react'
import className from 'classnames/bind'
import { Button } from 'app/components/common'
import { PlayArrowIcon } from 'app/components/icons'
import stylesModule from 'app/components/sounds/sound-popup/sound-popup-main/sound-popup-main.module.scss'
import { Sound } from 'app/components/sounds/types/sound'

const cx = className.bind(stylesModule)

type SoundPopupSongVideoButtonProps = { onVideoClick: () => void; sound: Sound }

const SoundPopupVideoButton = ({
  onVideoClick,
  sound,
}: SoundPopupSongVideoButtonProps) =>
  sound.video ? (
    <Button
      className={cx('media-button', 'green')}
      onClick={onVideoClick}
      aria-label={`Play video for ${sound.soundname}`}
    >
      <PlayArrowIcon className={cx('media-button__icon')} />
    </Button>
  ) : null

export default SoundPopupVideoButton
